import React from "react";
import { SvgProps } from ".";

export const ConfirmProductionSvg: React.FC<SvgProps> = () => {
  return (
    <svg width="69px" height="72px" viewBox="0 0 69 72" version="1.1">
      <title>Confirm-Production</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-178.000000, -149.000000)" strokeWidth="2">
          <g
            id="Confirm-Production"
            transform="translate(179.000000, 150.000000)"
          >
            <path
              d="M11.2609375,41.3076923 L11.2609375,3 C11.2609375,1.34314575 12.6040833,3.04359188e-16 14.2609375,0 L63.0576923,0 C64.7145466,1.39730022e-16 66.0576923,1.34314575 66.0576923,3 L66.0576923,53 L66.0576923,53 L56.8910256,48.7484663 L47.724359,53 L38.5576923,48.7484663 L29.3910256,53"
              id="Path"
              stroke="#1853A3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="33.5625"
              y1="24.8076923"
              x2="55.4373086"
              y2="24.8076923"
              id="Path"
              stroke="#1853A3"
              strokeLinecap="round"
              strokeLinejoin="round"
              fillRule="nonzero"
            />
            <line
              x1="33.5625"
              y1="12.3076923"
              x2="55.4373086"
              y2="12.3076923"
              id="Path"
              stroke="#1853A3"
              strokeLinecap="round"
              strokeLinejoin="round"
              fillRule="nonzero"
            />
            <line
              x1="33.5623086"
              y1="37.3076923"
              x2="55.4373086"
              y2="37.3076923"
              id="Path"
              stroke="#1853A3"
              strokeLinecap="round"
              strokeLinejoin="round"
              fillRule="nonzero"
            />
            <polyline
              id="Path"
              stroke="#1853A3"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="21.0625 11.5264423 24.1875 9.96394231 24.1875 20.9002704"
            />
            <path
              d="M21.2773789,29.6027294 C21.6823511,28.6445454 22.5958618,27.99908 23.6342809,27.9373972 C24.6727,27.8757144 25.6561995,28.4084961 26.1717572,29.312 C26.6873149,30.2155039 26.6456492,31.3332657 26.0642578,32.1958798 L21.0625,38.8701923 L26.5312643,38.8701923"
              id="Path"
              stroke="#1853A3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              id="Oval"
              stroke="#91EB8C"
              cx="11.25"
              cy="57.8076923"
              r="11.25"
            />
            <line
              x1="6.5625"
              y1="57.8240986"
              x2="15.9375"
              y2="57.8240986"
              id="Path"
              stroke="#91EB8C"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="11.2664063"
              y1="53.1201923"
              x2="11.2664063"
              y2="62.4951923"
              id="Path"
              stroke="#91EB8C"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default {};
